module.exports = __webpack_public_path__ + "components/outside-promo-page/static/hero-image-a5ff7801c77d29ded3a302eb8efe951e.webp";